import { createReducer, on } from '@ngrx/store';
import * as PurchaseActions from './purchases.actions';
import { Purchase } from './purchases.models';

// -----------------------------------------------------------------------------------------------------
// @ States
// -----------------------------------------------------------------------------------------------------

export interface PurchasesState {
    purchases: Purchase[];
    purchase: Purchase | null;
    isLoading: boolean;
    error: string | null;
}

// -----------------------------------------------------------------------------------------------------
// @ Initial States
// -----------------------------------------------------------------------------------------------------

export const initialPurchasesState: PurchasesState = {
    purchases: [],
    purchase: null,
    isLoading: false,
    error: null,
};

// -----------------------------------------------------------------------------------------------------
// @ Reducers
// -----------------------------------------------------------------------------------------------------

// Purchases Reducer
export const purchasesReducer = createReducer(
    initialPurchasesState,

    // On Load Purchases
    on(PurchaseActions.loadPurchases, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PurchaseActions.loadPurchasesSuccess, (state, { purchases }) => ({
        ...state,
        isLoading: false,
        purchases: purchases,
    })),
    on(PurchaseActions.loadPurchasesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Purchase
    // on(PurchaseActions.loadPurchase, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(PurchaseActions.loadPurchaseSuccess, (state, { purchase }) => ({
    //     ...state,
    //     isLoading: false,
    //     purchase: purchase,
    // })),
    // on(PurchaseActions.loadPurchaseFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // })),

    // On Create
    on(PurchaseActions.createPurchase, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PurchaseActions.createPurchaseSuccess, (state, { purchase }) => ({
        ...state,
        isLoading: false,
        purchases: [...(state.purchases || []), purchase],
    })),
    on(PurchaseActions.createPurchaseFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))

    // On Update
    //   on(PurchaseActions.updatePurchase, (state) => ({
    //     ...state,
    //     isLoading: true,
    //   })),
    //   on(PurchaseActions.updatePurchaseSuccess, (state, { purchase }) => ({
    //     ...state,
    //     isLoading: false,
    //     purchases: state.purchases.map((r) => (r.id === purchase.id ? purchase : r)),
    //   })),
    //   on(PurchaseActions.updatePurchaseFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    //   })),

    // On Delete
    //   on(PurchaseActions.deletePurchase, (state) => ({
    //     ...state,
    //     isLoading: true,
    //   })),
    //   on(PurchaseActions.deletePurchaseSuccess, (state, { id }) => ({
    //     ...state,
    //     isLoading: false,
    //     purchases: state.purchases.filter((r) => r.id !== id),
    //   })),
    //   on(PurchaseActions.deletePurchaseFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    //   }))
);
